// log version
console.log("nightTab version", version.get().number, version.get().name);
data.init();
state.init();
header.init();
bookmarks.init();
theme.init();
menu.init();
search.init();
link.init();
control.init();
greeting.init();
transitional.init();
date.init();
clock.init();
keyboard.init();
layout.init();
background.init();
modal.init();
shade.init();
dropdown.init();
edge.init();
version.init();
ready.init();
